import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { startAppUpdateChecks } from './appUpdate';
import './styles.css';

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);

window.addEventListener('load', () => void startAppUpdateChecks().catch(() => {
  // Update checks are best-effort and stay silent when offline or unsupported.
}));
